import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const TerreoPagina = () => {
  return (
    <div className="terreo-container">
      <GroupLightComponent
        groupIds={[
          "grupo01","grupo02","grupo03","grupo04","grupo05","grupo06","grupo07","grupo08","grupo09",
          "grupo10","grupo11","grupo12","grupo13","grupo14","grupo15","grupo16","grupo17","grupo18",
          "grupo19","grupo20","grupo21","grupo22","grupo23","grupo24","grupo25","grupo26","grupo27",
          "grupo28","grupo29","grupo30","grupo31","grupo32","grupo33","grupo34","grupo35","grupo36",
          "grupo37","grupo38","grupo39"
        ]}
        pageId="1"
      />
    </div>
  );
};

export default TerreoPagina;